// Determine if we're in development mode
// Checks both NODE_ENV (set during build) and hostname (runtime check)
// This ensures correct behavior in both development and production
const isDevelopment = process.env.NODE_ENV === 'development' || 
                      window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';

// Default domain - use localhost in development, production otherwise
// In production: NODE_ENV='production' and hostname='baapp.in', so DEFAULT_DOMAIN='https://baapp.in'
// In development: NODE_ENV='development' or hostname='localhost', so DEFAULT_DOMAIN='http://localhost:8000'
const DEFAULT_DOMAIN = isDevelopment ? 'http://localhost:8000' : 'https://baapp.in';

// API Configuration
// Priority: 1. REACT_APP_API_URL env var, 2. DEFAULT_DOMAIN (based on environment)
export const API_BASE = process.env.REACT_APP_API_URL || DEFAULT_DOMAIN;

// WebSocket Configuration
// Priority: 1. REACT_APP_WS_BASE env var, 2. Derived from DEFAULT_DOMAIN
// Production: wss://baapp.in, Development: ws://localhost:8000
export const WS_BASE =
  process.env.REACT_APP_WS_BASE ||
  (isDevelopment ? 'ws://localhost:8000' : DEFAULT_DOMAIN.replace('https://', 'wss://'));
